angular.module('lsnBase.deprecated.models')
  .factory('DocumentAttributeModel', ['LsnDocumentAttributeModelV1',
    function(LsnDocumentAttributeModelV1) {
      return LsnDocumentAttributeModelV1;
    }
  ]);